import { Observable } from 'rxjs'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
export abstract class StateGateway {
    private _url: string = ''
    abstract getAllStates(): Observable<ValidatedSelectOptionModel[]>
    abstract getAllStateRegions(): Observable<ValidatedSelectOptionModel[]>
    abstract getAllStatesforMailing(): Observable<ValidatedSelectOptionModel[]>
    abstract getStateCodeByZipCode(zipCode: string): Observable<ValidatedSelectOptionModel[]>

    abstract getRegionCodeByState(state: string): Observable<number>

    get url(): string {
        return this._url
    }
    set url(value: string) {
        this._url = value
    }
}
